export default "__VITE_ASSET__1ac0cc01__"